import { useTranslation } from 'react-i18next'

import { ProgramStatusBadge } from './Shared/ProgramStatusBadge'
import { ValidationSubmissionConfigurationResponse } from '@percent/admin-dashboard/api/actions/validationSubmissions/validationSubmissions.types'
import {
  Badge,
  Flex,
  Table,
  TableBody,
  TableCell,
  TableColumn,
  TableProvider,
  TableRow,
  Typography
} from '@percent/lemonade'

export function ProgramPartnerFields({
  isLoading,
  partnerFields
}: ValidationSubmissionConfigurationResponse & { isLoading: boolean }) {
  const { t } = useTranslation()

  const columns: TableColumn[] = [
    { id: 'id', content: t('typography.id'), props: { width: '10%' } },
    { id: 'title', content: t('typography.title'), props: { width: '25%' } },
    { id: 'type', content: t('typography.type'), props: { width: '25%' } },
    { id: 'required', content: t('typography.required'), props: { width: '10%' } },
    { id: 'options', content: t('typography.options'), props: { width: '30%' } }
  ]

  if (!partnerFields.length) return null

  return (
    <>
      <Typography variant="h2">{t('program.partnerFields')}</Typography>
      <TableProvider
        columns={columns}
        emptyTableDescription=""
        emptyTableTitle={t('typography.noResultsFound')}
        isLoading={isLoading}
        illustration="no-results"
        totalResults={partnerFields.length ?? 0}
      >
        <Table>
          <TableBody>
            {partnerFields.map(field => (
              <TableRow key={field.id}>
                <TableCell>
                  <Badge variant="default">{field.id}</Badge>
                </TableCell>
                <TableCell>
                  <Typography>{field.title}</Typography>
                </TableCell>
                <TableCell>
                  <Badge variant="default">{t(`program.label.partnerFields.type.${field.type}`)}</Badge>
                </TableCell>
                <TableCell>
                  <ProgramStatusBadge status={field.validation?.required ? 'on' : 'off'} />
                </TableCell>
                <TableCell>
                  <Flex direction="column" gap={4} align="start">
                    {field.options ? (
                      field.options?.map(option => (
                        <Badge variant="default" key={option.key}>
                          <Flex gap={12} align="baseline">
                            <b>{option.key}:</b>
                            <Typography>{option.value}</Typography>
                          </Flex>
                        </Badge>
                      ))
                    ) : (
                      <Badge variant="default">{t('status.na')}</Badge>
                    )}
                  </Flex>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableProvider>
    </>
  )
}
